import { commentPopoverReducers, storyControllerReducers } from './reducerTable'

export default ['$rootScope', commentMenuPopover]

// todo: daniel: make eventHandler modules for composable components
export function commentMenuPopover($rootScope) {
  return {
    restrict: 'EA',
    template: `
      <div ng-show="vm.visible">
        <i class="fa fa-ellipsis-v" ng-click="vm.setUi()"></i>
        <div class="comment-popover" ng-if="vm.ui" ng-transclude></div>
      </div>
    `,
    transclude: true,
    controllerAs: 'vm',
    bindToController: true,
    controller: function() {
      this.ui = false
      this.setUi = () => {
        this.ui = !this.ui
      }
      $rootScope.$on('CONTENT_COMMENT', (info, action) => {
        if (commentPopoverReducers[action.type]) {
          commentPopoverReducers[action.type].call(this, { action })
        }
        storyControllerReducers.COMMENT_REPOSITION()
      })
    },
    link: function(scope, elem, attrs, ctrl) {
      storyControllerReducers.COMMENT_REPOSITION()
    },
    scope: {
      index: '=',
      visible: '=',
      _id: '=cId',
      replyIndex: '=',
    },
  }
}
